import { render, staticRenderFns } from "./CustomNotification.vue?vue&type=template&id=e655d444&scoped=true&"
import script from "./CustomNotification.vue?vue&type=script&lang=js&"
export * from "./CustomNotification.vue?vue&type=script&lang=js&"
import style0 from "./CustomNotification.vue?vue&type=style&index=0&id=e655d444&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e655d444",
  null
  
)

export default component.exports